<script setup lang="ts"></script>

<template>
  <div
    id="wish-list"
    :class="[
      // TODO: Remove these classes once the styles are all moved to Tailwind and we're no longer using
      // any styles from the SCSS files.
      // `wish-list-v2` means excluding this component from using styles in app/assets/stylesheets/3/surface/show/layouts/*.scss
      'wish-list-v2',
      'wish-list',

      'z-wishlist',
    ]"
    tabindex="-1"
  >
    <slot />
  </div>
</template>
